import React from 'react'
import { Modal } from 'react-bootstrap'
import Calendar from 'react-calendar'
import MonthOfYear from 'common/logic/MonthOfYear'
import 'react-calendar/dist/Calendar.css'

interface Props {
    onSelect: (value: MonthOfYear | MonthOfYear[]) => void
    onClose: () => void
    show: boolean
    selectRange?: boolean
}

function MonthPicker({ onSelect, onClose, show, selectRange }: Props) {
    function onChange(value: Date | Date[]) {
        if (selectRange && Array.isArray(value)) {
            onSelect(value.map(d => MonthOfYear.fromDate(d)))
        } else {
            onSelect(MonthOfYear.fromDate(value as Date))
        }
    }

    return <>
        <Modal show={show} onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>Pick a month</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Calendar
                    maxDetail="year"
                    selectRange={!!selectRange}
                    onChange={onChange as any}
                />
            </Modal.Body>
        </Modal>
    </>
}

export default MonthPicker
